<template>
  <div class="page">
    <Header />
    <div class="concept-container">
      <div class="breadcrumb">
        <div class="left">
          <div class="item pointer" @click="goToPage('/home')">{{ $t('common.home') }}</div>
          <div class="icon">></div>
          <div class="item">{{ $t('culture.breadcrumb') }}</div>
        </div>
        <div class="right">
          <div class="sub-menu active" @click="goToPage('/culture-concept')">{{ $t('nav.culture') }}</div>
          <div class="sub-menu" @click="goToPage('/culture-solar')">{{ $t('culture.solarTitle') }}</div>
        </div>
      </div>
      <div class="page-header">
        <span>{{ $t('culture.pageHeaderCn') }}</span>
        <span class="icon">|</span>
        <span>{{ $t('culture.pageHeaderEn') }}</span>
      </div>
      <div class="concept-wrapper">
        <div class="content">
          <div class="hero">
            <video ref="heroVideo" autoplay muted loop playsinline>
              <source src="@/assets/images/culture/concept.mp4" type="video/mp4">
            </video>
          </div>

          <div class="section" v-for="(item, idx) in sections" :key="idx">
            <div class="section-title">
              <span class="dot"></span>
              <div class="text">
                <div class="cn">{{ item.cnTitle }}</div>
                <div class="cn-desc" v-for="(line, i) in item.cnDesc" :key="'cn' + i">{{ line }}</div>
              </div>
            </div>
            <div class="section-body">
              <div class="en">{{ item.enTitle }}</div>
              <div class="cn-desc" v-for="(line, i) in item.enDesc" :key="'cn' + i">{{ line }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <audio
      ref="bgm"
      autoplay
      loop
      preload="auto"
      :muted="bgmMuted"
      :src="bgmSrc"
      @canplay="tryPlayBgm(false)"
    />
  </div>
</template>
<script>

import Header from "@/views/commponents/header.vue";
import Footer from "@/views/commponents/footer.vue";

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      bgmSrc: process.env.BASE_URL + 'bg.mp3',
      bgmStarted: false,
      bgmMuted: false,
      bgmRetryTimers: [],
      sections: [
        {
          cnTitle: "使命",
          enTitle: "Mission",
          cnDesc: ["演义服饰，守正出奇，共当共赢，积健成雄"],
          enDesc: ["Bring Fabric to Life, Stay Grounded While Breaking New Ground, Share Burdens and Rewards, Feather upon Feather We Rise."]
        },
        {
          cnTitle: "愿景",
          enTitle: "Vision",
          cnDesc: ["有动力的智慧纺织先行者"],
          enDesc: ["A Leading Force Advancing Textile Innovation."]
        },
        {
          cnTitle: "核心价值观",
          enTitle: "Core Values",
          cnDesc: ["修诚向善，守德善新，扬善安和"],
          enDesc: [
            "Refine Sincerity Within, Foster Mutual Goodwill.Uphold Integrity in our Profession, Improve and Innovate in our Work.Advance Sustainable Good, Cultivate Harmonious Coexistence.",
          ]
        },
        {
          cnTitle: "营销战略目标",
          enTitle: "Market-facing Strategic Objective",
          cnDesc: ["可信赖的纺织与服饰设计、生产、营销灵活整合的供应链"],
          enDesc: [
            "Trust-inspiring Supply Chain Agility Integrating the Design, Manufacturing, Marketing of Textile and Apparel."
          ]
        },
        {
          cnTitle: "管理战略目标",
          enTitle: "Management Strategic Objectives",
          cnDesc: ["集团公司平台化，事业部分公司专业化，团队个体菁英化"],
          enDesc: [
            "Platformization of the Corporation, Professionalizing the Business Units, Empowering Top Talents."
          ]
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tryPlayBgm();
      this.scheduleBgmRetries();
    });
    this.bindBgmUnlockListeners();
    this.onPageShow = () => this.tryPlayBgm();
    this.onVisibilityChange = () => {
      if (!document.hidden) this.tryPlayBgm();
    };
    window.addEventListener('pageshow', this.onPageShow);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },
  beforeDestroy() {
    this.unbindBgmUnlockListeners();
    window.removeEventListener('pageshow', this.onPageShow);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.bgmRetryTimers.forEach((timer) => clearTimeout(timer));
    this.bgmRetryTimers = [];
  },
  methods: {
    bindBgmUnlockListeners() {
      this.startBgmOnce = () => {
        this.tryPlayBgm(true);
        this.unbindBgmUnlockListeners();
      };
      document.addEventListener('pointerdown', this.startBgmOnce);
      document.addEventListener('touchstart', this.startBgmOnce, { passive: true });
      document.addEventListener('wheel', this.startBgmOnce, { passive: true });
      document.addEventListener('keydown', this.startBgmOnce);
    },
    unbindBgmUnlockListeners() {
      if (!this.startBgmOnce) return;
      document.removeEventListener('pointerdown', this.startBgmOnce);
      document.removeEventListener('touchstart', this.startBgmOnce);
      document.removeEventListener('wheel', this.startBgmOnce);
      document.removeEventListener('keydown', this.startBgmOnce);
    },
    tryPlayBgm(fromUserGesture = false) {
      const el = this.$refs.bgm;
      if (!el) return;
      if (fromUserGesture) {
        this.bgmMuted = false;
        el.defaultMuted = false;
        el.muted = false;
        el.volume = 1;
        const gestureRet = el.play();
        if (gestureRet && typeof gestureRet.then === 'function') {
          gestureRet.then(() => {
            this.bgmStarted = true;
          }).catch(() => { });
        } else {
          this.bgmStarted = true;
        }
        return;
      }

      this.bgmMuted = false;
      el.defaultMuted = false;
      el.muted = false;
      el.volume = 1;
      const ret = el.play();
      if (ret && typeof ret.then === 'function') {
        ret.then(() => {
          this.bgmStarted = true;
        }).catch(() => {
          this.bgmMuted = true;
          el.defaultMuted = true;
          el.muted = true;
          const mutedRet = el.play();
          if (mutedRet && typeof mutedRet.then === 'function') {
            mutedRet.then(() => {
              this.bgmStarted = true;
            }).catch(() => { });
          }
        });
      } else {
        this.bgmStarted = true;
      }
    },
    scheduleBgmRetries() {
      const retryDelays = [300, 900, 1800, 3200];
      this.bgmRetryTimers = retryDelays.map((delay) => setTimeout(() => this.tryPlayBgm(), delay));
    },
    goToPage(path) {
      this.$router.push(path);
    },
  }
};
</script>

<style scoped lang="scss">
.concept-container {
  width: 100%;
  position: relative;
  overflow: hidden;

  .concept-wrapper {
    width: 100%;
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;

    .content {
      padding: 2vw 12.5vw 6vh;
      box-sizing: border-box;

      .title {
        font-size: var(--fs-nav);
        line-height: var(--lh-tight);
        color: #71151A;
        padding: 1.59vw 0;
        font-weight: 600;
      }

      .hero {
        width: 100%;
        height: min(32vw, 470px);
        min-height: 200px;
        margin-bottom: 5vh;
        overflow: hidden;

        video {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }
      }

      .section {
        border-bottom: 1px dashed #71141A;
        padding: 4vh 0;

        &:first-of-type {
          border-top: none;
          padding-top: 0;
        }

        .section-title {
          display: flex;
          margin-bottom: 12px;
          position: relative;

          .dot {
            width: 19px;
            height: 19px;
            background: #71141A;
            flex-shrink: 0;
            position: absolute;
            top: 6px;
            left: 0;

          }

          .text {
            padding-left: 40px;
            color: #333;
            font-size: var(--fs-body);
            line-height: var(--lh-normal);

            .cn {
              font-weight: bold;
            }

            //.cn-desc {
            //  font-size: 16px;
            //}
          }
        }

        .section-body {
          font-size: var(--fs-body-sm);
          line-height: var(--lh-loose);
          color: #333;
          font-weight: normal;
          padding-left: 40px;
        }
      }
    }
  }

}

@media (orientation: portrait) {
  .concept-container .concept-wrapper .content {
    padding-left: 2vw;
    padding-right: 2vw;
  }

  .concept-container .concept-wrapper .content .hero {
    height: min(48vw, 300px);
    min-height: 180px;
    margin-bottom: 1vh;
  }
}
</style>
